<template>
  <div id="kt_header" class="header align-items-stretch">
    <div
      class="container-fluid d-flex align-items-stretch justify-content-between"
    >
      <div
        class="d-flex align-items-center d-lg-none ms-n3 me-1"
        title="Show aside menu"
      >
        <div
          class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
          id="kt_aside_mobile_toggle"
        >
          <span class="svg-icon svg-icon-2x mt-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                fill="black"
              />
              <path
                opacity="0.3"
                d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                fill="black"
              />
            </svg>
          </span>
        </div>
      </div>

      <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
        <a href="" class="d-lg-none"> </a>
      </div>

      <div
        class="d-flex align-items-stretch justify-content-between flex-lg-grow-1"
      >
        <div class="d-flex align-items-center" id="kt_header_nav">
          <div
            data-kt-swapper="true"
            data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_header_nav'}"
            class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
          ></div>
        </div>

        <div class="d-flex align-items-stretch flex-shrink-0">
          <div
            class="d-flex align-items-center ms-3"
            v-if="karyawan.units.length > 1"
          >
            <select
              v-model="selectedUnit"
              class="form-select form-select-sm"
              style="width: auto"
              @change="changeUnit"
            >
              <option value="all">Semua Unit</option>
              <option
                v-for="unit in karyawan.units"
                :key="unit.id"
                :value="unit.id"
              >
                {{ unit.nama_unit }}
              </option>
            </select>
          </div>

          <div class="d-flex align-items-stretch flex-shrink-0">
            <div
              class="d-flex align-items-center ms-1 ms-lg-3"
              id="kt_header_user_menu_toggle"
            >
              <div
                class="cursor-pointer symbol symbol-30px symbol-md-40px"
                data-kt-menu-trigger="click"
                data-kt-menu-attach="parent"
                data-kt-menu-placement="bottom-end"
              >
                <img
                  v-if="karyawan.image"
                  :src="$App.config.baseUrlImage + karyawan.image"
                  alt="user"
                  style="object-fit: cover"
                />
                <img v-else src="@/assets/img/blank.png" alt="user" />
              </div>

              <div
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-success fw-bold py-4 fs-6 w-275px"
                data-kt-menu="true"
              >
                <div class="menu-item px-3">
                  <div class="menu-content d-flex align-items-center px-3">
                    <div class="symbol symbol-50px me-5">
                      <img
                        alt="Logo"
                        :src="$App.config.baseUrlImage + karyawan.image"
                        v-if="karyawan.image"
                        style="object-fit: cover"
                      />
                      <img alt="Logo" src="@/assets/img/blank.png" v-else />
                    </div>

                    <div class="d-flex flex-column">
                      <div class="fw-bolder d-flex align-items-center fs-5">
                        {{ karyawan.nama_karyawan }}
                      </div>
                      <a
                        href="#"
                        class="fw-bold text-muted text-hover-success fs-7"
                        >{{ karyawan.nama_jabatan }}</a
                      >
                    </div>
                  </div>
                </div>

                <div class="separator my-2"></div>

                <div class="menu-item px-5">
                  <a @click="logout" class="menu-link px-5">Sign Out</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Config from "../config";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
// import toastr from "toastr";
import moment from "moment";
// import Pusher from "pusher-js";

export default {
  name: "HeaderLayout",

  data() {
    return {
      urlImage: Config.baseUrlImage,
      theme: "light",
      notification: [],
      alert: null,
      channel: null,
      selectedUnit:
        localStorage.getItem("selectedUnit") != null &&
        localStorage.getItem("selectedUnit") != "all"
          ? parseInt(localStorage.getItem("selectedUnit"))
          : "all",
    };
  },

  methods: {
    fromNow(time) {
      return moment(time).fromNow(true);
    },
    // readNotification(data) {
    //   const content = JSON.parse(data.content);
    //   switch (data.type) {
    //     case "Lembur":
    //       this.$router
    //         .push("/lembur/detail/" + content.id_lembur)
    //         .then(() => {
    //           this.$axios
    //             .put("/notif/read/" + data.id_notification_detail)
    //             .then((res) => {
    //               this.notification = res.data.data;
    //             });
    //         })
    //         .catch((err) => {
    //           // NavigationDuplicated
    //           if (err.name !== "NavigationDuplicated") {
    //             throw err;
    //           }
    //         });
    //       break;
    //     case "Official Duty":
    //       this.$router
    //         .push("/official-duty/detail/" + content.id_penugasan)
    //         .then(() => {
    //           this.$axios
    //             .put("/notif/read/" + data.id_notification_detail)
    //             .then((res) => {
    //               this.notification = res.data.data;
    //             });
    //         })
    //         .catch((err) => {
    //           // NavigationDuplicated
    //           if (err.name !== "NavigationDuplicated") {
    //             throw err;
    //           }
    //         });
    //       break;
    //     case "Izin":
    //       this.$router
    //         .push("/izin/detail/" + content.id_izin)
    //         .then(() => {
    //           this.$axios
    //             .put("/notif/read/" + data.id_notification_detail)
    //             .then((res) => {
    //               this.notification = res.data.data;
    //             });
    //         })
    //         .catch((err) => {
    //           // NavigationDuplicated
    //           if (err.name !== "NavigationDuplicated") {
    //             throw err;
    //           }
    //         });
    //       break;
    //     default:
    //       this.$router.push("/dashboard");
    //   }
    // },
    logout() {
      Swal.fire({
        title: "Apakah anda yakin?",
        text: "Anda akan keluar dari aplikasi ini!",
        icon: "warning",
        showCancelButton: true,
        buttonsStyling: !1,
        confirmButtonText: "Ya, saya yakin!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios.post("/logout").then(() => {
            this.$store.commit("setToken", "");
            this.$store.commit("setExptimestamp", 0);
          });
        }
      });
    },

    changeUnit() {
      this.$store.commit("setSelectedUnit", this.selectedUnit);
    },

    changeTheme(theme) {
      if (theme == "light") {
        document.body.setAttribute("data-theme", "light");
        this.theme = "light";
        localStorage.setItem("theme", "light");
        this.$vuetify.theme.dark = false;
        Config.monthConfig.plugins = [
          new monthSelectPlugin({
            shorthand: true,
            altFormat: "F Y",
            dateFormat: "Y-m",
          }),
        ];
      } else if (theme == "dark") {
        document.body.setAttribute("data-theme", "dark");
        this.theme = "dark";
        localStorage.setItem("theme", "dark");
        import("flatpickr/dist/themes/dark.css");
        this.$vuetify.theme.dark = true;
        Config.monthConfig.plugins = [
          new monthSelectPlugin({
            shorthand: true,
            altFormat: "F Y",
            dateFormat: "Y-m",
            theme: "dark",
          }),
        ];
      } else {
        const getMatchedTheme = window.matchMedia(
          "(prefers-color-scheme: dark)"
        ).matches;

        if (getMatchedTheme) {
          document.body.setAttribute("data-theme", "dark");
          this.theme = "system";
          localStorage.setItem("theme", "system");
          import("flatpickr/dist/themes/dark.css");
          this.$vuetify.theme.dark = true;
          Config.monthConfig.plugins = [
            new monthSelectPlugin({
              shorthand: true,
              altFormat: "F Y",
              dateFormat: "Y-m",
              theme: "dark",
            }),
          ];
        } else {
          document.body.setAttribute("data-theme", "light");
          this.theme = "system";
          localStorage.setItem("theme", "system");
          this.$vuetify.theme.dark = false;
          Config.monthConfig.plugins = [
            new monthSelectPlugin({
              shorthand: true,
              altFormat: "F Y",
              dateFormat: "Y-m",
              theme: "light",
            }),
          ];
        }
      }
    },

    // getNotif() {
    //   this.$axios.get("/notif").then((res) => {
    //     this.notification = res.data.data;
    //   });
    // },

    // webNotif(title, message) {
    //   // Use Browser Notification
    //   if (Notification.permission === "granted") {
    //     // if focused on the page, don't show notification
    //     if (document.hasFocus()) {
    //       return;
    //     }

    //     const notification = new Notification(title, {
    //       body: message,
    //     });

    //     notification.onclick = () => {
    //       window.focus();
    //       notification.close();
    //     };
    //   }
    // },
  },

  mounted() {
    // if (this.notification.length == 0) {
    //   setTimeout(() => {
    //     this.getNotif();
    //   }, 5000);
    // }
    // const getMatchedTheme = window.matchMedia(
    //   "(prefers-color-scheme: dark)"
    // ).matches;
    // const theme = localStorage.getItem("theme");
    // if (theme == "light") {
    //   document.body.setAttribute("data-theme", "light");
    //   this.theme = "light";
    // } else if (theme == "dark") {
    //   document.body.setAttribute("data-theme", "dark");
    //   this.theme = "dark";
    // } else {
    //   if (getMatchedTheme) {
    //     document.body.setAttribute("data-theme", "dark");
    //     this.theme = "system";
    //   } else {
    //     document.body.setAttribute("data-theme", "light");
    //     this.theme = "system";
    //   }
    // }
    // this.channel = this.$pusher.subscribe(
    //   "private-alert-notif-" + this.$store.state.user.user_id
    // );
    // this.channel.bind("App\\Events\\Notif", (data) => {
    //   this.notification = data;
    // });
    // this.channel.bind("App\\Events\\Alert", (data) => {
    //   this.alert = data;
    // });

    if (this.karyawan.units.length == 1) {
      this.selectedUnit = this.karyawan.units[0].id;
      this.$store.commit("setSelectedUnit", this.selectedUnit);
    }
  },

  watch: {
    "$store.state.token": function (val) {
      if (val) {
        try {
          const decodedPayloadToken = JSON.parse(
            atob(this.$store.state.token.split(".")[1])
          );

          this.$store.commit("setUser", decodedPayloadToken);
        } catch (e) {
          return "Unknown User";
        }
      }
    },

    // channel: function (val) {
    //   if (val) {
    //     this.channel.bind("App\\Events\\Notif", (data) => {
    //       this.notification = data;
    //     });

    //     this.channel.bind("App\\Events\\Alert", (data) => {
    //       this.alert = data;
    //     });
    //   }
    // },

    // alert: {
    //   handler: function (val) {
    //     toastr.options = {
    //       closeButton: true,
    //       debug: false,
    //       newestOnTop: false,
    //       progressBar: true,
    //       positionClass: "toast-top-right",
    //       preventDuplicates: false,
    //       onclick: null,
    //       showDuration: "300",
    //       hideDuration: "1000",
    //       timeOut: "5000",
    //       extendedTimeOut: "1000",
    //       showEasing: "swing",
    //       hideEasing: "linear",
    //       showMethod: "fadeIn",
    //       hideMethod: "fadeOut",
    //     };

    //     toastr[val.variant](`${val.name} : ${val.message}`, val.type);
    //     if (!("Notification" in window)) {
    //       // Check if the browser supports notifications
    //       alert("This browser does not support desktop notification");
    //     } else if (Notification.permission === "granted") {
    //       this.webNotif(val.type, `${val.name} : ${val.message}`);
    //     } else if (Notification.permission !== "denied") {
    //       // We need to ask the user for permission
    //       Notification.requestPermission().then((permission) => {
    //         // If the user accepts, let's create a notification
    //         if (permission === "granted") {
    //           // const notification = new Notification("Hi there!");
    //           this.webNotif(val.type, `${val.name} : ${val.message}`);
    //         }
    //       });
    //     }
    //   },
    //   deep: true,
    // },
  },

  computed: {
    karyawan: function () {
      if (this.$store.state.token) {
        try {
          const decodedPayloadToken = JSON.parse(
            atob(this.$store.state.token.split(".")[1])
          );

          const user = {
            id_karyawan: decodedPayloadToken.id_karyawan,
            nama_karyawan: decodedPayloadToken.nama_karyawan,
            nama_jabatan: decodedPayloadToken.nama_jabatan,
            image: decodedPayloadToken.foto,
            units: decodedPayloadToken.units ?? [],
          };
          return user;
        } catch (e) {
          return "Unknown User";
        }
      }
      return "Unknown User";
    },
  },
};
</script>
